import { LegacyTimelineMonths } from './LegacyTimelineMonths';

export { LegacyTimelineMonths };
export default LegacyTimelineMonths;
